// Prioridad de los pedidos para armar el día (25-oct-2026). La calcula el backend por el motivo
// (pierde agua → urgente, limpieza → baja) y el admin la cambia a mano. La empresa no la ve.
export const PRIORIDADES = [
    { id: 'URGENTE', label: 'Urgente', ayuda: 'Pierde agua, no anda, cliente enojado', clase: 'bg-brand-red text-white' },
    { id: 'ALTA',    label: 'Alta',    ayuda: 'No enfría, no calienta, canilla',      clase: 'bg-[#F0A500] text-[#1C1917]' },
    { id: 'NORMAL',  label: 'Normal',  ayuda: 'Instalaciones',                       clase: 'bg-chip text-ink' },
    { id: 'BAJA',    label: 'Baja',    ayuda: 'Limpieza, retiro',                    clase: 'bg-chip text-muted' },
];
export const PRIORIDAD = Object.fromEntries(PRIORIDADES.map(p => [p.id, p]));

export function ChipPrioridad({ nivel, className = '' }) {
    const p = PRIORIDAD[nivel];
    if (!p) return null;
    return <span className={`inline-flex items-center h-5 px-1.5 rounded-md text-[11px] font-black uppercase tracking-wide shrink-0 ${p.clase} ${className}`}>{p.label}</span>;
}
